'use strict';

var _ = require('lodash');

var eventsManager = {
  create: function create() {
    var registry = {};
    return {
      on: function on(eventName, callback) {
        registry[eventName] = registry[eventName] || [];
        registry[eventName].push(callback);
      },
      off: function off(eventName, callback) {
        registry[eventName] = _.reject(registry[eventName], function (c) {
          return c === callback;
        });
      },
      emit: function emit(eventName) {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        var registeredCallbacks = registry[eventName];

        _(registeredCallbacks).slice().forEach(function (callback) {
          callback.apply(void 0, params);
        });
      }
    };
  }
};
module.exports = eventsManager;
//# sourceMappingURL=eventsManager.js.map